import type { QueryClient } from 'react-query';

let appQueryClient: QueryClient | null = null;

export function setAppQueryClient(client: QueryClient | null): void {
  appQueryClient = client;
}

export function getAppQueryClient(): QueryClient | null {
  return appQueryClient;
}
